import React, { useState } from "react";
import Sidebar from "../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar";
import WorkerBottomNav from "../../components/serviceprovider/workerdashboard/Workernavbar/WorkerBottomNav";
// import WorkerTopbar from "../../components/serviceprovider/workerdashboard/workertopbar/WorkerTopbar";
import "../../assets/css/screens/serviceprovider/layouts/workermasterlayout/WorkerMasterLayout.css";

const MasterLayout = ({
  children,
  showBottomNav = true
}) => {
  const [activeMenu,    setActiveMenu]    = useState("dashboard");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(prev => !prev);
  const closeSidebar  = () => setIsSidebarOpen(false);

 return (
  <div className="worker-layout">

    <Sidebar
      isOpen={isSidebarOpen}
      activeMenu={activeMenu}
      setActiveMenu={setActiveMenu}
      onClose={closeSidebar}
    />

    <div className="layout-main">
      <main className="layout-content">
        {children}
      </main>
    </div>

    {showBottomNav && <WorkerBottomNav />}

    {isSidebarOpen && (
      <div
        className="wml-sidebar-overlay"
        onClick={closeSidebar}
      />
    )}

  </div>
);
};

export default MasterLayout;